import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 24",
	stroke: "var(--control-selected-mark, #0C5661)",
	fill: "var(--control-selected-bg, #79FBAF)",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		width: 24,
		height: 24,
		rx: "var(--checkbox-radius, 8)",
		stroke: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.25 13.181L11.0988 16.0286L16.794 10.3334",
		fill: "none",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckboxSelected;
